/*
  Bundle Gifts controller
  =======================
  Tier- en subscription-aware free gifts voor de bundle-producten. De config
  komt LIVE uit de email-popup app (/api/bundle-config), dezelfde bron als de
  discount-Function die de gifts gratis maakt. Zo kunnen thema en Function
  nooit uit sync raken.

  Eligibility-regels (identiek aan de Function):
  - een tier is gehaald zodra de regel-quantity >= buy + free (= group);
  - tiers stapelen cumulatief (Buy 3 krijgt ook de Buy 2-gifts);
  - applies (all | onetime | subscription) wordt getoetst aan de bundle-regel,
    niet aan de gift-regel; gifts zelf zijn altijd one-time;
  - een bundelkaart die een EIGEN product toevoegt (Detox Bundle) telt als de
    hoogste staffel van zijn hostproduct, zie BUNDLE_HOST_PROP.

  Let op bij bewerken: dit bestand bevat met opzet GEEN reguliere expressies.
  Ze zijn vervangen door tekstvergelijkingen omdat de backslashes er twee keer
  uit zijn gevallen bij het versturen naar de theme API, en een kapotte regex
  hier zet de hele gift-afhandeling stil zonder dat de winkel er iets van laat
  zien.
*/
(function () {
  'use strict';

  var cfgEl = document.getElementById('bundle-gifts-config');
  if (!cfgEl) return;
  var SETTINGS;
  try {
    SETTINGS = JSON.parse(cfgEl.textContent);
  } catch (_e) {
    return;
  }
  if (!SETTINGS || !SETTINGS.apiBase || !SETTINGS.shop) return;

  var GIFT_PROP = '_bundle_gift';
  /**
   * Gezet door skipToCheckout in shop-product-details.liquid op een bundelkaart
   * die een eigen product toevoegt in plaats van meer units van het PDP-product:
   * de Detox Bundle is een regel van een ander product, met quantity 1. Zonder
   * deze property viel zo'n regel buiten alles hieronder. De injectie sloeg hem
   * over omdat zijn variant niet van het huidige product is, en de watcher las
   * quantity 1 en kwam op de laagste staffel uit. Gemeten op de live winkel:
   * de checkout toonde alleen Detox Bundle x1, zonder zelfs de Scratch and Win
   * die group 1 al toekent.
   */
  var BUNDLE_HOST_PROP = '_bundle_host';
  var configCache = null;
  var configPromise = null;
  var currentProductVariants = null;

  function isCartPath(url, verb) {
    return String(url || '').indexOf('/cart/' + verb) !== -1;
  }

  function loadCurrentProductVariants() {
    if (!SETTINGS.productId) return;
    try {
      fetch(window.location.pathname + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) {
          if (p && String(p.id) === String(SETTINGS.productId) && Array.isArray(p.variants)) {
            currentProductVariants = {};
            p.variants.forEach(function (v) { currentProductVariants[String(v.id)] = true; });
          }
        })
        .catch(function () {});
    } catch (_e) { /* noop */ }
  }

  var quarantined = {};

  function loadConfig() {
    if (configPromise) return configPromise;
    configPromise = fetch(
      SETTINGS.apiBase + '/api/bundle-config?shop=' + encodeURIComponent(SETTINGS.shop)
    )
      .then(function (r) { return r.ok ? r.json() : { products: [] }; })
      .then(function (j) {
        configCache = j && Array.isArray(j.products) ? j : { products: [] };
        return configCache;
      })
      .catch(function () {
        configCache = { products: [] };
        return configCache;
      });
    return configPromise;
  }

  function appliesMatch(applies, isSub) {
    if (!applies || applies === 'all') return true;
    if (applies === 'onetime') return !isSub;
    if (applies === 'subscription') return isSub;
    return true;
  }

  function productConfig(config, productId) {
    if (!config || !config.products) return null;
    for (var i = 0; i < config.products.length; i++) {
      if (String(config.products[i].id) === String(productId)) return config.products[i];
    }
    return null;
  }

  /**
   * De hoogste group die voor een product is geconfigureerd, oftewel de
   * zwaarste staffel. Voor deze winkel is dat group 5, de 3+2.
   *
   * Waarom een bundelkaart daarop uitkomt en niet op zijn quantity: de
   * merchant-afspraak is dat de Detox Bundle altijd als 3+2 telt. Het thema
   * zet er ook _bundle_tier: bundle3 op, en dat getal lees ik bewust NIET; het
   * spreekt de afspraak tegen, en een getal volgen dat de bedoeling tegenspreekt
   * is erger dan het niet volgen. Moet er ooit per bundel een andere staffel
   * komen, zet dan het juiste getal in het thema en lees het hier uit.
   */
  function topTierGroup(productCfg) {
    var top = 0;
    var tiers = (productCfg && productCfg.tiers) || [];
    for (var i = 0; i < tiers.length; i++) {
      var g = Number(tiers[i] && tiers[i].group);
      if (g > top) top = g;
    }
    return top;
  }

  function giftsForQty(productCfg, qty, isSub, includeIneligible) {
    var out = {};
    if (!productCfg) return [];
    (productCfg.tiers || []).forEach(function (t) {
      if (!t || qty < t.group) return;
      (t.gifts || []).forEach(function (g) {
        if (!g || !g.id) return;
        var ok = appliesMatch(g.applies, isSub);
        if (!ok && !includeIneligible) return;
        if (!out[g.id]) out[g.id] = { gift: g, eligible: false, qty: 0 };
        if (ok) { out[g.id].qty = 1; out[g.id].eligible = true; }
      });
    });
    return Object.keys(out).map(function (k) { return out[k]; });
  }

  function isSubActive() {
    var c = window.subscriptionContext;
    return !!(c && c.sellingPlanId);
  }

  function selectedTierQty() {
    var input = document.querySelector('.quantity-break-option.selected input.quantity-break-input');
    if (!input) return 0;
    var v = parseInt(input.value, 10);
    return isNaN(v) ? 0 : v;
  }

  var syncingForm = false;

  function syncFormGifts() {
    if (syncingForm) return;
    syncingForm = true;
    try {
      var form =
        (typeof Elixir_GetProductForm === 'function' && Elixir_GetProductForm()) ||
        document.querySelector('form[action*="cart/add"].product-buy-form-pdp');
      if (!form) return;

      var existing = form.querySelector('.bundle-gift-items');

      var entries = [];
      if (SETTINGS.productId && configCache) {
        var pc = productConfig(configCache, SETTINGS.productId);
        if (pc) {
          entries = giftsForQty(pc, selectedTierQty(), isSubActive(), false)
            .filter(function (e) { return e.qty > 0; });
        }
      }

      var maxIndex = 0;
      var otherItemInputs = 0;
      form.querySelectorAll('input[name^="items["]').forEach(function (inp) {
        if (existing && existing.contains(inp)) return;
        otherItemInputs++;
        if (inp.name.slice(0, 6) === 'items[') {
          var n = parseInt(inp.name.slice(6), 10);
          if (!isNaN(n) && n > maxIndex) maxIndex = n;
        }
      });

      var desired = '';
      if (entries.length && otherItemInputs > 0) {
        desired = JSON.stringify(entries.map(function (e) { return [e.gift.id, e.qty]; })) + '@' + maxIndex;
      }
      var current = existing ? existing.getAttribute('data-signature') || '' : '';
      if (desired === current) return;

      if (existing) existing.remove();
      if (!desired) return;

      var wrap = document.createElement('div');
      wrap.className = 'bundle-gift-items';
      wrap.setAttribute('data-signature', desired);
      entries.forEach(function (entry, i) {
        var idx = maxIndex + 1 + i;
        [
          ['items[' + idx + '][id]', String(entry.gift.id)],
          ['items[' + idx + '][quantity]', String(entry.qty)],
          ['items[' + idx + '][properties][' + GIFT_PROP + ']', '1'],
        ].forEach(function (pair) {
          var input = document.createElement('input');
          input.type = 'hidden';
          input.name = pair[0];
          input.value = pair[1];
          wrap.appendChild(input);
        });
      });
      form.appendChild(wrap);
    } catch (_e) {
      /* nooit de PDP breken */
    } finally {
      syncingForm = false;
    }
  }

  var formObserver = null;
  function observeForm() {
    var form =
      (typeof Elixir_GetProductForm === 'function' && Elixir_GetProductForm()) ||
      document.querySelector('form[action*="cart/add"].product-buy-form-pdp');
    if (!form || formObserver) return;
    var pending = false;
    formObserver = new MutationObserver(function () {
      if (pending || syncingForm) return;
      pending = true;
      setTimeout(function () { pending = false; syncFormGifts(); }, 30);
    });
    formObserver.observe(form, { childList: true, subtree: true });
  }

  document.addEventListener('submit', function (ev) {
    try {
      var form = ev.target;
      if (form && form.matches && form.matches('form[action*="cart/add"]') &&
          !form.classList.contains('free-product-form')) {
        syncFormGifts();
      }
    } catch (_e) { /* noop */ }
  }, true);

  var origFetch = window.fetch;
  var syncScheduled = false;
  var syncRunning = false;

  /**
   * KERN VAN DE CHECKOUT-FIX: gifts worden IN de /cart/add-request zelf
   * geinjecteerd (request-body herschrijven) in plaats van achteraf door de
   * watcher. Alleen zo halen ze flows die direct na de add wegnavigeren
   * (skip-to-checkout, express payment buttons); de watcher verliest daar de
   * race van de redirect.
   *
   * Veiligheidsregels:
   * - alleen als de toegevoegde variant van HET HUIDIGE product is, of als de
   *   regel via _bundle_host naar dat product verwijst (upsells en
   *   threshold-gift-forms blijven onaangeroerd);
   * - alleen requests zonder sections-param (drawer-flows verwachten een
   *   sections-response; die krijgen hun gift via de watcher);
   * - bij elke parse-onzekerheid: niets herschrijven, watcher is het vangnet.
   */
  function rewriteAddBody(init) {
    if (!init || !init.body || !configCache || !SETTINGS.productId || !currentProductVariants) return null;
    var pc = productConfig(configCache, SETTINGS.productId);
    if (!pc) return null;

    var mainItems = [];
    var body = init.body;
    var entries = null;
    if (typeof FormData !== 'undefined' && body instanceof FormData) {
      entries = [];
      body.forEach(function (v, k) { entries.push([k, String(v)]); });
    } else if (typeof URLSearchParams !== 'undefined' && body instanceof URLSearchParams) {
      entries = [];
      body.forEach(function (v, k) { entries.push([k, String(v)]); });
    } else if (typeof body === 'string') {
      try {
        var j = JSON.parse(body);
        if (j && Array.isArray(j.items)) {
          mainItems = j.items.map(function (it) { return Object.assign({}, it); });
        } else if (j && j.id) {
          var one = { id: Number(j.id), quantity: Number(j.quantity) || 1 };
          if (j.selling_plan) one.selling_plan = j.selling_plan;
          if (j.properties) one.properties = j.properties;
          mainItems = [one];
        } else return null;
      } catch (_e) {
        try { entries = []; new URLSearchParams(body).forEach(function (v, k) { entries.push([k, String(v)]); }); }
        catch (_e2) { return null; }
      }
    } else return null;

    if (entries) {
      var flat = {}; var props = {}; var hasItemsMode = false;
      entries.forEach(function (pair) {
        var k = pair[0], v = pair[1];
        if (k === 'sections' || k === 'sections_url') { flat.__sections = true; }
        if (k.slice(0, 6) === 'items[') hasItemsMode = true;
        if (k.slice(0, 11) === 'properties[' && k.slice(-1) === ']') {
          props[k.slice(11, -1)] = v;
          return;
        }
        flat[k] = v;
      });
      if (flat.__sections) return null;
      if (hasItemsMode) return null;
      if (!flat.id) return null;
      var main = { id: Number(flat.id), quantity: parseInt(flat.quantity, 10) || 1 };
      if (flat.selling_plan) main.selling_plan = flat.selling_plan;
      if (Object.keys(props).length) main.properties = props;
      mainItems = [main];
    }
    if (!mainItems.length) return null;

    var totalQty = 0; var isSub = false; var touchesCurrent = false;
    for (var i = 0; i < mainItems.length; i++) {
      var it = mainItems[i];
      if (it.properties && it.properties[GIFT_PROP]) return null;
      if (currentProductVariants[String(it.id)]) {
        touchesCurrent = true;
        totalQty += Number(it.quantity) || 1;
        if (it.selling_plan) isSub = true;
      } else if (it.properties &&
                 String(it.properties[BUNDLE_HOST_PROP] || '') === String(SETTINGS.productId)) {
        /* Bundelkaart met een eigen product (Detox Bundle). Telt voor de
           zwaarste staffel van de host in plaats van voor zijn quantity van 1,
           zie topTierGroup. Moet gelijk blijven aan runSync hieronder, anders
           haalt de watcher er weer uit wat hier net is toegevoegd. */
        touchesCurrent = true;
        var hostQty = topTierGroup(pc);
        if (hostQty > totalQty) totalQty = hostQty;
        if (it.selling_plan) isSub = true;
      }
    }
    if (!touchesCurrent || totalQty <= 0) return null;

    var gifts = giftsForQty(pc, totalQty, isSub, false).filter(function (e) { return e.qty > 0; });
    if (!gifts.length) return null;

    gifts.forEach(function (entry) {
      var p2 = {}; p2[GIFT_PROP] = '1';
      mainItems.push({ id: Number(entry.gift.id), quantity: entry.qty, properties: p2 });
    });

    var newInit = Object.assign({}, init);
    newInit.body = JSON.stringify({ items: mainItems });
    var headers = new Headers(init.headers || {});
    headers.set('Content-Type', 'application/json');
    headers.set('Accept', 'application/json');
    newInit.headers = headers;
    return newInit;
  }

  window.fetch = function (input, init) {
    var url = '';
    try {
      url = String((input && input.url) || input || '');
    } catch (_e) { /* noop */ }
    if (isCartPath(url, 'add')) {
      try {
        var rewritten = rewriteAddBody(init);
        if (rewritten) init = rewritten;
      } catch (_e) { /* nooit de add breken */ }
    }
    var p = origFetch.call(this, input, init);
    if (isCartPath(url, 'add') || isCartPath(url, 'change') ||
        isCartPath(url, 'update') || isCartPath(url, 'clear')) {
      p.then(function () { scheduleSync(); }, function () {});
    }
    return p;
  };

  function scheduleSync() {
    if (syncScheduled) return;
    syncScheduled = true;
    setTimeout(runSync, 450);
  }

  function cartMutation(path, payload) {
    return origFetch(path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload),
    });
  }

  async function runSync() {
    syncScheduled = false;
    if (syncRunning) { scheduleSync(); return; }

    /* De drawer adresseert regels op POSITIENUMMER, niet op key. Verwijderen wij
       hier een regel terwijl zijn eigen /cart/change onderweg is, dan schuift
       alles eronder een plaats op en leest hij een positie die niet meer
       bestaat. Vandaar dezelfde stilte van 1200ms als de opruimer in
       cart-drawer.liquid. */
    if (Date.now() - (window.__cartUserAction || 0) < 1200) { scheduleSync(); return; }

    syncRunning = true;
    try {
      var config = await loadConfig();
      if (!config.products || !config.products.length) return;

      var cart = await (await origFetch('/cart.js', { headers: { Accept: 'application/json' } })).json();
      var items = cart.items || [];

      /* De gratis eenheden van een bundel staan op een EIGEN regel.
         De PDP splitst "Buy 2, Get 1 FREE" in een betaalde regel (quantity 2)
         en een regel met _bundle_free (quantity 1). Een staffel is buy + free,
         dus group 3 - maar de betaalde regel leest 2, en 2 < 3. Group 3 werd
         daardoor nooit gehaald en de Pill Organizer, die alleen in group 3 en 5
         zit, werd als niet-verdiend weggegooid zodra de bezoeker terugkwam van
         de checkout. Daar was hij nog wel gratis meegegaan, want de injectie bij
         add-to-cart kent de gekozen bundelkaart en dus de echte staffel; deze
         bewaker rekende hem daarna omlaag. */
      var freeQty = {};
      items.forEach(function (line) {
        var p = line.properties || {};
        if (p[GIFT_PROP]) return;
        if (p._bundle_free === 'true' || p._bundle_free === true) {
          freeQty[line.variant_id] = (freeQty[line.variant_id] || 0) + line.quantity;
        }
      });

      var eligible = {};
      items.forEach(function (line) {
        if (line.properties && line.properties[GIFT_PROP]) return;
        /* De gratis regel telt hierboven al mee bij zijn betaalde tegenhanger.
           Hem hier nog eens los beoordelen geeft een tweede, lagere uitkomst:
           quantity 1 en zonder selling plan, dus zonder abonnement - waardoor
           juist de abonnementsgifts afvielen. */
        if (line.properties && (line.properties._bundle_free === 'true' || line.properties._bundle_free === true)) return;
        /* Een bundelkaart hangt via _bundle_host aan het product waarvan de
           staffels gelden, en telt daar voor de zwaarste staffel. Zonder deze
           twee regels leest de watcher quantity 1, komt op de laagste staffel
           uit, en verwijdert precies de gifts die rewriteAddBody er zojuist in
           heeft gezet. De twee moeten dezelfde uitkomst geven. */
        var host = line.properties && line.properties[BUNDLE_HOST_PROP];
        var pc = productConfig(config, host || line.product_id);
        if (!pc) return;
        var isSub = !!line.selling_plan_allocation;
        var qty = host ? topTierGroup(pc) : line.quantity + (freeQty[line.variant_id] || 0);
        (pc.tiers || []).forEach(function (t) {
          if (!t || qty < t.group) return;
          (t.gifts || []).forEach(function (g) {
            if (!g || !g.id) return;
            if (appliesMatch(g.applies, isSub)) {
              eligible[g.id] = { gift: g, qty: 1 };
            }
          });
        });
      });

      var present = {};
      var mutated = false;
      var updates = {};

      for (var i = 0; i < items.length; i++) {
        var line = items[i];
        if (!line.properties || !line.properties[GIFT_PROP]) continue;
        var vid = line.variant_id;

        if (!eligible[vid] || quarantined[vid]) {
          updates[line.key] = 0;
          mutated = true;
          continue;
        }
        if (line.quantity !== eligible[vid].qty) {
          updates[line.key] = eligible[vid].qty;
          mutated = true;
          present[vid] = true;
          continue;
        }
        if (line.final_line_price > 0) {
          /* VANGNET: de Function heeft deze regel niet gratis gemaakt. Weg
             ermee, een klant mag nooit voor een gift betalen. Niet opnieuw
             toevoegen deze page-load. */
          quarantined[vid] = true;
          updates[line.key] = 0;
          mutated = true;
          continue;
        }
        present[vid] = true;
      }

      if (Object.keys(updates).length) {
        await cartMutation('/cart/update.js', { updates: updates });
      }

      var toAdd = [];
      Object.keys(eligible).forEach(function (vid) {
        if (!present[vid] && !quarantined[vid]) {
          var props = {};
          props[GIFT_PROP] = '1';
          toAdd.push({ id: Number(vid), quantity: eligible[vid].qty, properties: props });
        }
      });
      if (toAdd.length) {
        await cartMutation('/cart/add.js', { items: toAdd });
        mutated = true;
        scheduleSync();
      }

      if (mutated) refreshDrawer();
    } catch (_e) {
      /* stil falen: nooit de winkel breken */
    } finally {
      syncRunning = false;
    }
  }

  function refreshDrawer() {
    try {
      var drawer = document.querySelector('cart-drawer');
      if (!drawer || !window.cartFunctions || !window.cartFunctions.updateCartDrawer) return;
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      origFetch(root + 'cart?section_id=cart-drawer')
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('#CartDrawer');
          if (fresh) window.cartFunctions.updateCartDrawer(drawer, fresh, false, null);
        })
        .catch(function () {});
    } catch (_e) { /* noop */ }
  }

  var STRIP_ID = 'bundle-gifts-strip';

  function renderStrip() {
    var strip = document.getElementById(STRIP_ID);
    if (strip) strip.remove();
  }

  function onStateChange(delay) {
    setTimeout(function () { renderStrip(); syncFormGifts(); }, delay);
  }
  document.addEventListener('change', function (ev) {
    if (ev.target && ev.target.classList && ev.target.classList.contains('quantity-break-input')) {
      onStateChange(50);
    }
  });
  document.addEventListener('click', function (ev) {
    if (ev.target && ev.target.closest && ev.target.closest('.quantity-break-option')) {
      onStateChange(100);
    }
  });
  document.addEventListener('subscriptionContext:updated', function () {
    onStateChange(50);
  });

  function init() {
    loadCurrentProductVariants();
    loadConfig().then(function () {
      renderStrip();
      syncFormGifts();
      observeForm();
      onStateChange(600);
      onStateChange(1500);
      scheduleSync();
    });
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
